var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDotsVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3333 13.3333C13.0697 13.3333 13.6667 12.7364 13.6667 12C13.6667 11.2636 13.0697 10.6667 12.3333 10.6667C11.597 10.6667 11 11.2636 11 12C11 12.7364 11.597 13.3333 12.3333 13.3333Z",
    fill: "#4C545B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3333 8.66667C13.0697 8.66667 13.6667 8.06971 13.6667 7.33333C13.6667 6.59695 13.0697 6 12.3333 6C11.597 6 11 6.59695 11 7.33333C11 8.06971 11.597 8.66667 12.3333 8.66667Z",
    fill: "#4C545B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3333 18C13.0697 18 13.6667 17.403 13.6667 16.6667C13.6667 15.9303 13.0697 15.3333 12.3333 15.3333C11.597 15.3333 11 15.9303 11 16.6667C11 17.403 11.597 18 12.3333 18Z",
    fill: "#4C545B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsVertical);
export default __webpack_public_path__ + "static/media/dots-vertical.c6dbe2448f825c1e9dd44893338c2f68.svg";
export { ForwardRef as ReactComponent };